import { ProductType, View } from '@/types';
import { getHasSleeves } from './getHasSleeves';
import { getViewByPerspective } from './getViewByPerspective';

const LEFT_SLEEVE = 'left';
const RIGHT_SLEEVE = 'right';
const SLEEVES = [LEFT_SLEEVE, RIGHT_SLEEVE];

export const getOtherSleeveView = (productType: ProductType, view: View): View | undefined =>
  getHasSleeves(productType) && SLEEVES.includes(view.perspective)
    ? getViewByPerspective(
        productType,
        view.perspective === LEFT_SLEEVE ? RIGHT_SLEEVE : LEFT_SLEEVE
      )
    : undefined;
